import React from 'react';
import { colors } from '@chegg-ui/theme';
import { DeleteIcon } from '@chegg-ui/horizon-icons';
import { DeleteContributorButton, Wrapper } from './styled';
import { ContributorInputLabels, CONTRIBUTOR_TEST_ID } from './constants';
import { Input } from '../../Shared';
import { Dropdown } from '../../Shared/Dropdown';
import { TestIds } from '../constants';
export var Contributor = function Contributor(_ref) {
  var index = _ref.index,
    functionOptions = _ref.functionOptions,
    removeContributor = _ref.removeContributor;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-test": CONTRIBUTOR_TEST_ID,
    className: "wf-contributors"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    name: "contributors[".concat(index, "].function"),
    labelText: ContributorInputLabels.FUNCTION,
    options: functionOptions,
    className: "function"
  }), /*#__PURE__*/React.createElement(Input, {
    name: "contributors[".concat(index, "].firstName"),
    labelText: ContributorInputLabels.FIRST,
    className: "first",
    isRecommended: true
  }), /*#__PURE__*/React.createElement(Input, {
    name: "contributors[".concat(index, "].middleName"),
    labelText: ContributorInputLabels.MIDDLE,
    className: "middle"
  }), /*#__PURE__*/React.createElement(Input, {
    name: "contributors[".concat(index, "].lastName"),
    labelText: ContributorInputLabels.LAST,
    className: "last",
    isRecommended: true
  }), /*#__PURE__*/React.createElement(Input, {
    name: "contributors[".concat(index, "].data.suffix"),
    labelText: ContributorInputLabels.SUFFIX,
    className: "suffix"
  }), /*#__PURE__*/React.createElement(DeleteContributorButton, {
    size: 'small',
    onClick: removeContributor,
    screenReaderOnlyText: "delete contributor",
    "data-test": TestIds.DELETE_CONTRIBUTOR_BUTTON
  }, /*#__PURE__*/React.createElement(DeleteIcon, {
    size: "small",
    svgColor: colors.dark
  })));
};